import { DataSource } from '@angular/cdk/collections';
import { NotificationDatabase } from './notification-database';
export class NotificationDataSource extends DataSource<any> {
  constructor(private _notificationDatabase: NotificationDatabase) {
    super();
  }
  connect() {
    return this._notificationDatabase.dataChange;
  }
  disconnect() { }
}
